// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__RYtvn","hole":"styles_hole__5qXi-","info":"styles_info__13HNF","gray":"styles_gray__3fzpE"};